import React, { useMemo, useState } from 'react';
import { useUsersChartData } from '../../../api/hooks/useUsersChartData';
import { UsersWidgets } from './Widgets';
import { UsersChart } from './Chart';
import { DateRangeFilter } from '../DateRangeFilter';
import { useTranslate } from 'ra-core';
import { MoonstarTitle } from '../../Moonstar/MoonstarTitle';
import { Card, CardContent } from '../../../components/ui/card';

export const UsersAnalytics: React.FC = () => {
  const translate = useTranslate();

  const now = useMemo(() => new Date(), []);

  const [after, setAfter] = useState(() => {
    const thirtyDaysAgo = new Date(now);
    thirtyDaysAgo.setDate(now.getDate() - 30);

    return thirtyDaysAgo.toISOString().split('T')[0]!;
  });

  const [before, setBefore] = useState(() => now.toISOString().split('T')[0]!);

  const { data } = useUsersChartData({
    after: new Date(after).toISOString(),
    before: new Date(before).toISOString(),
  });

  const analyticsLabel = translate('moonstar.analytics.name');
  const usersLabel = translate('resources.users.name', {
    count: 2,
  });

  return (
    <>
      <MoonstarTitle breadcrumb={[usersLabel, analyticsLabel]} />
      <UsersWidgets />
      <Card className="mb-4 shadow-md">
        <CardContent className="gap-4 p-4">
          <DateRangeFilter
            startDate={after}
            endDate={before}
            setStartDate={setAfter}
            setEndDate={setBefore}
            minDate="2025-01-10" // This is when we started tracking user data. We have no user analytics data before this date
          />
        </CardContent>

        <CardContent className="grid grid-cols-1 gap-4 p-4 pt-0 md:grid-cols-2">
          <div>
            <UsersChart
              title={translate('moonstar.dashboard.users.engaged.title')}
              chartData={data?.engaged || []}
              dataKey="count"
              lineName={translate('moonstar.dashboard.users.engaged.line')}
              includePercentage={true}
              percentageLineName={translate(
                'moonstar.dashboard.users.engaged.percentage'
              )}
            />
          </div>
          <div>
            <UsersChart
              title={translate('moonstar.dashboard.users.activated.title')}
              chartData={data?.activated || []}
              dataKey="count"
              lineName={translate('moonstar.dashboard.users.activated.line')}
              includePercentage={true}
              percentageLineName={translate(
                'moonstar.dashboard.users.activated.percentage'
              )}
            />
          </div>
          <div>
            <UsersChart
              title={translate('moonstar.dashboard.users.onboarded.title')}
              chartData={data?.onboarded || []}
              dataKey="count"
              lineName={translate('moonstar.dashboard.users.onboarded.line')}
              includePercentage={false}
            />
          </div>
        </CardContent>
      </Card>
    </>
  );
};
